import * as React from "react";

const SvgIcnLine = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <g fillRule="nonzero" stroke="none" strokeWidth={1} fill="none">
            <path
                d="M11.551 20.505c3.298-1.593 5.611-3.32 7.093-5.106.24-.29 1.003-1.365 1.138-1.609.318-.574.531-1.18.631-1.806l.003-.015c.033-.177.054-.338.063-.483.01-.16.004-.41-.009-.637-.202-3.517-3.916-6.347-8.48-6.347-4.71 0-8.489 3.006-8.489 6.65 0 3.317 3.148 6.15 7.357 6.591a.989.989 0 01.879 1.093l-.186 1.67z"
                stroke="currentColor"
            />
            <path
                d="M7.047 12.6V9.59a.46.46 0 00-.92 0v3.471c0 .254.207.46.46.46h1.84a.46.46 0 000-.92h-1.38zM9.884 13.52h-.201a.36.36 0 01-.36-.36V9.489c0-.198.161-.359.36-.359h.2c.2 0 .36.161.36.36v3.672a.36.36 0 01-.36.36zM13.6 9.589v2.12s-1.837-2.394-1.865-2.426a.458.458 0 00-.36-.154.472.472 0 00-.442.479v3.452a.46.46 0 00.92 0v-2.108s1.863 2.416 1.89 2.442c.082.077.191.125.312.126.255.002.464-.223.464-.479V9.59a.46.46 0 00-.92 0zM17.967 9.589a.46.46 0 00-.46-.46h-1.839a.46.46 0 00-.46.46v3.471c0 .254.207.46.46.46h1.84a.46.46 0 000-.92h-1.38v-.816h1.38a.46.46 0 000-.92h-1.38v-.815h1.38a.46.46 0 00.46-.46z"
                fill="currentColor"
            />
        </g>
    </svg>
);

export default SvgIcnLine;
